import type { DefaultOptions } from '@tanstack/react-query';

/** The SPA's query defaults. Tests build their client from these too, so they see what the app does. */
export const APP_QUERY_DEFAULTS: NonNullable<DefaultOptions['queries']> = {
  staleTime: 30_000,
  refetchOnWindowFocus: false,
  retry: (count, error) => {
    const status = (error as { status?: number }).status;
    return status !== undefined ? status >= 500 && count < 2 : count < 2;
  },
};

/**
 * For every query that reads member-written text. Each view must reach the server, because
 * the server writes the audit row before it answers. staleTime 0 and gcTime 0 keep a later
 * mount, or a filter changed back, from showing cached text that no request paid for.
 */
export const AUDITED_READ = { staleTime: 0, gcTime: 0 } as const;
